import StyleFactory, { getPropFromFeature, getNumberFromFeatureProps } from '../../StyleFactory';
import { getUnitFactor } from '../../utils/unitConversion';
import hurricaneGeometry, { circleGeometry } from '../geom/hurricaneGeometry';

const themeLabelSelector = () => ({
  text: {
    offsetY: 10,
    offsetX: 70
  },
  zIndex: 3
});

const themeCircleSelector = (value, theme, feature, resolution, params) => {
  const {
    time
  } = params;
  const props = feature.getProperties();
  const {
    EndTime: endTime,
    StartTime: startTime
  } = props;
  const fillColor = 'transparent';
  let strokeColor = theme.color.future;
  let zIndex = 1;

  if (time >= new Date(startTime).getTime() && time < new Date(endTime).getTime()) {
    strokeColor = theme.color.barbs;
    zIndex = 2;
  }

  if (time >= new Date(endTime).getTime()) {
    strokeColor = theme.color.past;
  }

  return {
    stroke: {
      color: strokeColor,
      width: 1
    },
    fill: {
      color: fillColor
    },
    zIndex
  };
};

const themeHurricaneSelector = (value, theme, feature, resolution, params) => {
  const unitConvenerFactor = getUnitFactor(params.unit);
  const speedKN = Math.round(+value * unitConvenerFactor);
  const R = resolution / speedKN;
  let fillColor = theme.color.barbs;
  const strokeColor = theme.color.barbs;

  if (R >= 50 && speedKN <= 63) {
    fillColor = 'transparent';
  }

  return {
    stroke: {
      color: strokeColor,
      width: 1
    },
    fill: {
      color: fillColor
    },
    zIndex: 2
  };
};

const labelSelector = feature => {
  const value = getNumberFromFeatureProps('WindSpeed')(feature);
  return `${getPropFromFeature('HurricaneName')(feature)} (${Math.round(value)})`;
};

const hurricaneView = StyleFactory.createStyle({
  labelSelector: null,
  valueSelector: getPropFromFeature('WindSpeed'),
  geometry: hurricaneGeometry({
    sizeFactor: 7,
    count: 8
  }),
  themeSelector: themeHurricaneSelector
});
const labelStyle = StyleFactory.createStyle({
  valueSelector: getPropFromFeature('WindSpeed'),
  labelSelector,
  themeSelector: themeLabelSelector
});
const circleView = StyleFactory.createStyle({
  labelSelector: null,
  valueSelector: getPropFromFeature('WindSpeed'),
  geometry: circleGeometry({
    sizeFactor: 0.1
  }),
  themeSelector: themeCircleSelector
});
export default ((...args) => (feature, resolution, params) => {
  const {
    time
  } = params;
  const props = feature.getProperties();
  const {
    EndTime: endTime,
    StartTime: startTime
  } = props;

  if (time >= new Date(startTime).getTime() && time < new Date(endTime).getTime()) {
    return [labelStyle(...args)(feature, resolution, params), circleView(...args)(feature, resolution, params), hurricaneView(...args)(feature, resolution, params)];
  }

  return circleView(...args)(feature, resolution, params);
});